import page from "./pages.json";
import common from "./common.json";
import v2Common from "./v2-common.json";
import tobetranslated from "./tobetranslated.json";
import notifications from "./notifications.json";
import products from "./products.json";
import customerExperiences from "./customer-experiences.json";
import dashboard from "./dashboard.json";
import messages from "./messages.json";
import nav from "./nav.json";
import account from "./account.json";
import reports from "./reports.json";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  nav,
  page,
  messages,
  common,
  v2Common,
  tobetranslated,
  notifications,
  products,
  customerExperiences,
  dashboard,
  account,
  reports,
};
